module.exports = __webpack_public_path__ + "static/media/github-logo.3afed5f8.svg";